// import store from '@/store';
// import moment from "moment";
import consts from "@/consts";
import {getMainParentRouteName} from "@/lib/lib";

const defaultSetRoute = {
    users: (route, router) => {
        if(route.meta?.mainRouteName !== consts.routerNames.users.main) {
            if(consts.app.$isDevelopment) console.warn('users', route);
            return false
        }
        router.push({
            name: consts.routerNames.users.main,
            params: {},
            query: {}
        })
    },
    usersClearQuery: (route, router) => {
        if(route.meta?.mainRouteName !== consts.routerNames.users.main) {
            if(consts.app.$isDevelopment) console.warn('usersClearQuery', route);
            return false
        }
        router.push({
            name: route.name,
            params: {
                ...route.params,
            },
            query: {}
        })
    },
    usersEdit: (route, router, userId, filter) => {
        if(route.meta?.mainRouteName !== consts.routerNames.users.main) {
            if(consts.app.$isDevelopment) console.warn('usersEdit', route);
            return false
        }
        let query = filter ? {...route.query, ...filter} : route.query
        router.push({
            name: consts.routerNames.users.edit.main,
            params: {
                userId,
            },
            query: {...query}
        })
    },
    userCustomizeEdit: (route, router, userId, filter) => {
        if(route.meta?.mainRouteName !== consts.routerNames.users.main) {
            if(consts.app.$isDevelopment) console.warn('usersEdit', route);
            return false
        }
        let query = filter ? {...route.query, ...filter} : route.query
        router.push({
            name: consts.routerNames.users.edit.customize,
            params: {
                userId,
            },
            query: {...query}
        })
    },
    userCustomizeBackgroundEdit: (route, router, userId, filter) => {
        if(route.meta?.mainRouteName !== consts.routerNames.users.main) {
            if(consts.app.$isDevelopment) console.warn('usersEdit', route);
            return false
        }
        let query = filter ? {...route.query, ...filter} : route.query
        router.push({
            name: consts.routerNames.users.edit.customizeBackground,
            params: {
                userId,
            },
            query: {...query}
        })
    },
    editAccessRight: (route, router, userId, filter) => {
        if(route.meta?.mainRouteName !== consts.routerNames.users.main) {
            if(consts.app.$isDevelopment) console.warn('usersEdit', route);
            return false
        }
        let query = filter ? {...route.query, ...filter} : route.query
        router.push({
            name: consts.routerNames.users.edit.accessRights,
            params: {
                userId,
            },
            query: {...query}
        })
    },
    userServicesEdit: (route, router, userId, filter) => {
        if(route.meta?.mainRouteName !== consts.routerNames.users.main) {
            if(consts.app.$isDevelopment) console.warn('usersEdit', route);
            return false
        }
        let query = filter ? {...route.query, ...filter} : route.query
        router.push({
            name: consts.routerNames.users.edit.services,
            params: {
                userId,
            },
            query: {...query}
        })
    },
    usersCreate: (route, router) => {
        if(route.meta?.mainRouteName !== consts.routerNames.users.main) {
            if(consts.app.$isDevelopment) console.warn('usersCreate', route);
            return false
        }
        router.push({
            name: consts.routerNames.users.edit.create,
            params: {
            },
            query: {...route.query}
        })
    },
    userChangePassword: (route, router, userId) => {
        if(route.meta?.mainRouteName !== consts.routerNames.users.main) {
            if(consts.app.$isDevelopment) console.warn('userChangePassword', route);
            return false
        }
        router.push({
            name: consts.routerNames.users.edit.password,
            params: {
                userId,
            },
            query: {...route.query}
        })
    },
    usersHistory: (route, router, userId) => {
        if(route.meta?.mainRouteName !== consts.routerNames.users.main) {
            if(consts.app.$isDevelopment) console.warn('usersHistory', route);
            return false
        }
        router.push({
            name: consts.routerNames.users.history,
            params: {
                userId,
            },
            query: {...route.query}
        })
    },
    userSetupDns: (route, router, userId) => {
        if(route.meta?.mainRouteName !== consts.routerNames.users.main) {
            if(consts.app.$isDevelopment) console.warn('userSetupDns', route);
            return false
        }
        router.push({
            name: consts.routerNames.users.edit.setup_dns,
            params: {
                userId,
            },
            query: {...route.query}
        })
    },
    globalUserEdit: (route, router) => {
        if(route.meta?.mainRouteName !== consts.routerNames.users.main) {
            if(consts.app.$isDevelopment) console.warn('globalUserEdit', route);
            return false
        }
        router.push({
            name: route.name + '.' + consts.routerNames.app.user.edit.default,
            params: {},
            query: {...route.query}
        })
    },
    returnToParent: (route, router) => {
        if(route.meta?.mainRouteName !== consts.routerNames.users.main) {
            if(consts.app.$isDevelopment) console.warn('globalUserEdit', route);
            return false
        }
        let name = route.meta?.parentRouteName || consts.routerNames.users.main;
        router.push({
            name: name,
            params: {
                ...route.params,
            },
            query: {...route.query}
        })
    },
}

const routes = (process.env.VUE_APP_PACKAGE !== 'prometheus.admin') ? [] : [
    {
        path: 'users',
        name: consts.routerNames.users.main,
        meta: {
            mainRouteName: consts.routerNames.users.main,
            bodyGrid: "1X1",
            showHead: true,
            setRoute: defaultSetRoute,
        },
        component: () => import('@/views/prometheus/admin/UsersPage.vue'),
        children: [
            {
                path: 'app/edit',
                name: consts.routerNames.users.main+ '.' + consts.routerNames.app.user.edit.default,
                meta: {
                    blockingRoutesTransitionFromOutside: true,
                    sectionWidgetByRoute: true
                },
                components: {
                    sectionWidgetByRoute: () => import('@/components/app/sectionInfo/UserSettings.vue'),
                }
            },
            {
                path: 'create',
                name: consts.routerNames.users.edit.create,
                meta: {
                    blockingRoutesTransitionFromOutside: true,
                    sectionPopupByRoute: {
                        SectionWrapByRoutePopup: {
                            titlePosition: 'center',
                        }
                    }
                },
                props: {
                    sectionPopupByRoute: () => ({
                        wrapper: 'EditWizard',
                        class: 'popup-body',
                    })
                },
                components: {
                    sectionPopupByRoute: () => import('@/components/users/user-edit/UserEdit.vue'),
                }
            },
            {
                path: ':userId(\\d+)/edit',
                name: consts.routerNames.users.edit.main,
                meta: {
                    blockingRoutesTransitionFromOutside: true,
                    sectionInfoByRoute: true
                },
                props: {
                    sectionInfoByRoute: (route) => {
                        let active = route.query?.active;
                        let props = {
                            userId: route.params?.userId,
                            wrapper: 'EditSegmentControl_vertical',
                            time: Date.now(),
                        }
                        if (active) props.activeComponent = active;
                        return props;
                    }
                },
                components: {
                    sectionInfoByRoute: () => import('@/components/users/user-edit/UserEdit.vue'),
                }
            },
            {
                path: ':userId(\\d+)/edit/customize',
                name: consts.routerNames.users.edit.customize,
                meta: {
                    blockingRoutesTransitionFromOutside: true,
                    sectionInfoByRoute: true
                },
                props: {
                    sectionInfoByRoute: (route) => {
                        let active = route.query?.active;
                        let props = {
                            userId: route.params?.userId,
                            wrapper: 'EditSegmentControl_vertical',
                            time: Date.now(),
                        }
                        if (active) props.activeComponent = active;
                        return props;
                    }
                },
                components: {
                    sectionInfoByRoute: () => import('@/components/users/user-customize-edit/UserCustomizeEdit.vue'),
                }
            },
            {
                path: ':userId(\\d+)/edit/customize-background',
                name: consts.routerNames.users.edit.customizeBackground,
                meta: {
                    mainRouteName: consts.routerNames.users.main,
                    blockingRoutesTransitionFromOutside: true,
                    sectionPopupByRoute: {
                        SectionWrapByRoutePopup: {
                            // class: 'popup-full',
                            titlePosition: 'center'
                        }
                    },
                    setRoute: {
                        ...defaultSetRoute,
                        returnToParent: (route, router) => {
                            if (getMainParentRouteName(route.meta?.mainRouteName) !== consts.routerNames.users.main) {
                                if (consts.app.$isDevelopment) console.warn(consts.routerNames.users.main + ' returnToParent', route);
                                return false;
                            }
                            router.push({
                                name: consts.routerNames.users.edit.customize,
                                params: {
                                    ...route.params,
                                },
                                query: {}
                            })
                        },
                    }
                },
                props: {
                    sectionPopupByRoute: (route) => ({
                        userId: route.params.userId,
                        wrapper: 'EditWizard',
                        class: 'popup-body',
                        options: {components: ['UserCustomizeEdit_backgrounds']},
                    })
                },
                components: {
                    sectionPopupByRoute: () => import('@/components/users/user-customize-edit/UserCustomizeEdit.vue'),
                }
            },
            {
                path: ':userId(\\d+)/change-password',
                name: consts.routerNames.users.edit.password,
                meta: {
                    blockingRoutesTransitionFromOutside: true,
                    sectionInfoByRoute: true
                },
                props: {
                    sectionInfoByRoute: (route) => ({
                        userId: route.params?.userId,
                        time: Date.now(),
                        wrapper: 'EditSegmentControl_vertical',
                        options: {components: ['UserEdit_Password']}
                    })
                },
                components: {
                    sectionInfoByRoute: () => import('@/components/users/user-edit/UserEdit.vue'),
                }
            },
            {
                path: ':userId(\\d+)/history',
                name: consts.routerNames.users.history,
                meta: {
                    sectionPopupByRoute: {
                        SectionWrapByRoutePopup: {
                            class: 'popup-full',
                            titlePosition: 'left'
                        }
                    }
                },
                props: {
                    sectionPopupByRoute: (route) => ({
                        objectName: 'user',
                        objectId: route.params.userId,
                    })
                },
                components: {
                    sectionPopupByRoute: () => import('@/components/objects_audit/objects/ObjectsChangesTableTreeList.vue'),
                }
            },
            {
                path: ':userId(\\d+)/setup-dns',
                name: consts.routerNames.users.edit.setup_dns,
                meta: {
                    blockingRoutesTransitionFromOutside: true,
                    sectionPopupByRoute: {
                        SectionWrapByRoutePopup: {
                            titlePosition: 'center',
                        }
                    }
                },
                props: {
                    sectionPopupByRoute: (route) => ({
                        userId: route.params.userId,
                        wrapper: 'EditWizard',
                        class: 'popup-body',
                    })
                },
                components: {
                    sectionPopupByRoute: () => import('@/components/users/sectionPopup/WizardDnsSetup.vue'),
                }
            },
            {
                path: ':userId(\\d+)/edit/services',
                name: consts.routerNames.users.edit.services,
                meta: {
                    blockingRoutesTransitionFromOutside: true,
                    sectionInfoByRoute: true
                },
                props: {
                    sectionInfoByRoute: (route) => {
                        let active = route.query?.active;
                        let props = {
                            userId: route.params?.userId,
                            wrapper: 'EditSegmentControl_vertical',
                            time: Date.now(),
                        }
                        if (active) props.activeComponent = active;
                        return props;
                    }
                },
                components: {
                    sectionInfoByRoute: () => import('@/components/users/user-services-edit/UserServicesEdit.vue'),
                }
            },
            {
                path: ':userId(\\d+)/edit/access-rights',
                name: consts.routerNames.users.edit.accessRights,
                meta: {
                    mainRouteName: consts.routerNames.users.main,
                    blockingRoutesTransitionFromOutside: true,
                    sectionPopupByRoute: {
                        SectionWrapByRoutePopup: {
                            // class: 'popup-full',
                            titlePosition: 'center',
                            hideSteps: true,
                        }
                    },
                },
                props: {
                    sectionPopupByRoute: (route) => ({
                        userId: +route.params.userId,
                        wrapper: 'EditWizard',
                        hideSteps: true,
                    })
                },
                components: {
                    sectionPopupByRoute: () => import('@/components/access-right/AccessRightEdit.vue'),
                }
            },
        ]
    },
];

export default routes;